import { Component, OnInit, Input, OnDestroy } from '@angular/core';
import { Chart } from 'angular-highcharts';
import { Highcharts$, Constants, DateService, Moment$, FabricService } from 'src/app/shared/index';
import { Hierarchy } from 'src/app/models/index';
import * as cloneDeep from 'lodash/cloneDeep';
import { PlantServiceService, SiteService, CommonService, LoadService } from 'src/app/services';
import { ActivatedRoute, Router } from '@angular/router';
import { fabric, Canvas } from 'fabric';
import { BehaviorSubject, Subject, timer, Subscription, combineLatest } from 'rxjs';
import { MatDialog } from '@angular/material';
import { SensorTrendModalComponent } from '../sensor-trend-modal/sensor-trend-modal.component';
import { DatePipe, DecimalPipe } from '@angular/common';

@Component({
  selector: 'app-plant-navigation',
  templateUrl: './plant-navigation.component.html',
  styleUrls: ['./plant-navigation.component.scss']
})
export class PlantNavigationComponent extends Hierarchy implements OnInit, OnDestroy {
  // tslint:disable-next-line:no-input-rename
  @Input('site-detail') siteDetail: any;
  siteRId: any;
  siteId: any;
  layoutNavigationFeatureTreeData = [];
  sensorData = [];
  sensorDetails = [];
  canvasOriginalWidth: number;
  canvasOriginalHeight = 650;
  canvasWidth: number;
  canvasHeight = 650;
  imgWidth: number;
  imgHeight: 650;
  canvasScaleX = 1;
  canvasScaleY = 1;
  canvas: Canvas;
  canvasGroup: fabric.Group;
  currentMousePosition: any;
  nodeId: string;
  nodeName: string;
  breadcrumlist: any;
  oddSensors: any;
  evenSensors: any;
  oddcharts = [];
  evencharts = [];
  barIconPath = './assets/img/barIcon.png';
  lineIconPath = './assets/img/lineIcon.png';
  barGrayIconPath = './assets/img/barGrayIcon.png';
  lineGrayIconPath = './assets/img/lineGrayIcon.png';
  public customBreadcrumbMessage = '';
  private componentDestroyed$: Subject<any> = new Subject();
  private customBreadcrumbs$ = new BehaviorSubject<any[]>([]);
  public customBreadcrumbs = this.customBreadcrumbs$.asObservable();

  subscription: Subscription;
  interval = undefined;
  minutes = 60 * 2; // Update charts each 2 mins

  alertSubscription: Subscription;
  alertInterval = undefined;
  alertMinutes = 60 * 0.5; // Update alert each 0.5 min
  
  sensorLastUpdatedTxtime: string;
  hasImageData = false;
  loadRTData: any;
  rtDataLength = -1;
  displayHydraulicDataTable = false;
  objectKeys = Object.keys;
  units = {
    'current': 'Amps',
    'powerfactor': '',
    'realtimepower': 'kW',
    'voltage': 'V'
  };
  txtime = '';

  // Alert
  todayAlert = 0;
  thisWeekAlert = 0;
  thisMonthAlert = 0;

  constructor(private plantService: PlantServiceService, private siteService: SiteService,
    private activeRoute: ActivatedRoute, private router: Router, private fabricService: FabricService,
    private dialog: MatDialog, private commonService: CommonService, private datePipe: DatePipe,
    private loadService: LoadService) {
    super();
  }

  ngOnInit() {
    this.breadcrumlist = [];
    const urlParams = combineLatest(
      this.activeRoute.params,
      this.activeRoute.queryParams,
      (params, queryParams) => ({ ...params, ...queryParams })
    );
    // Subscribe to the single observable, giving us both
    urlParams.subscribe(routeParams => {
      this.siteId = routeParams.siteId;
      this.plantService.getSiteDetail(this.siteId).subscribe(siteDetail => {
        this.siteDetail = siteDetail;
        this.siteService.getTreeConfiguration(this.siteDetail.siteId, ['layoutNavigationFeatureTreeData']).subscribe(data => {
          this.layoutNavigationFeatureTreeData = JSON.parse(data.layoutNavigationFeatureTreeData);
          this.dataSource.data = this.buildFileTree(this.layoutNavigationFeatureTreeData[0], this.dataSource.data, null);

          const first = this.dataSource.data[0];
          const model = { nodeId: first.nodeId, NodeName: first.title, siteID: this.siteDetail.siteId };
          this.getNodeImage(model);
        });

      });
    });
  }

  ngOnDestroy() {
    if (this.subscription) {
      this.subscription.unsubscribe();
    }

    if (this.alertSubscription) {
      this.alertSubscription.unsubscribe();
    }
  }

  private getNodeImage(model) {
    this.siteService.getAttachmentsForNode(model).subscribe(nodeInfo => {
      if (nodeInfo) {
        this.setBreabcrum(model.nodeId, model.NodeName);
        this.initLoadImageCanvas(nodeInfo.HtmlWithDIVContents, model);

        this.hasImageData = true;
      } else {
        this.hasImageData = false;
      }

    });
  }
  private initLoadImageCanvas = (jsonContent: string, model) => {
    const seft = this;
    this.displayBreabcrum();
    setTimeout(() => {
      const canvasId = 'loadImgCanvas';
      const e = document.querySelector('#wrapper');
      this.deleteChild(e);
      this.addCanvas(e, canvasId);

      this.canvas = new fabric.Canvas(canvasId, {
        hoverCursor: 'pointer',
        selection: false,
        selectionBorderColor: 'green',
        backgroundColor: null,
      });
      this.setCanvasSize();
      const self = this;
      this.canvas.loadFromJSON(jsonContent, (image: any) => {
        self.canvas.on('mouse:dblclick', self.onImageClick);
        // Remove control bouder when seleting object / Prevent moving object
        const objs = self.canvas.getObjects().map(function (o) {
          const nodeId = o._objects[2].text;
          const nodeName = o._objects[1].text;
          return o.set('hasControls', false).set('hasBorders', false).set('lockMovementX', true).set('lockMovementY', true);
        });
        self.canvas.renderAll();
        if (this.subscription) {
          this.subscription.unsubscribe();
        }
        if (this.alertSubscription) {
          this.alertSubscription.unsubscribe();
        }

        seft.interval = timer(0, seft.minutes * 1000);
        this.subscription = seft.interval.subscribe(() => {
          seft.getSensorTrendForGadgets(model);
        });
        
        seft.updateAlertCount(model);
      });

    }, 200);
  }
  deleteChild(wrapper) {
    let child = wrapper.lastElementChild;
    while (child) {
      wrapper.removeChild(child);
      child = wrapper.lastElementChild;
    }
  }
  addCanvas(wrapper, canvasId) {
    const elem = document.createElement('canvas');
    elem.setAttribute('id', canvasId);
    wrapper.appendChild(elem);
  }
  displayBreabcrum() {
    const nodelist = [];
    this.breadcrumlist.forEach(item => {
      nodelist.push(item.nodeName);
    });
    this.customBreadcrumbs$.next(nodelist);
  }
  setBreabcrum(nodeId, nodeName) {
    let isExisted = false;
    this.breadcrumlist.forEach(item => {
      if (item.nodeId === nodeId) {
        isExisted = true;
        return;
      }
    });
    if (!isExisted) {
      this.breadcrumlist.push({ nodeId, nodeName });
    }
  }
  customBreadcrumbClicked(title: string) {
    this.breadcrumlist.forEach((item, index) => {
      if (item.nodeName === title) {
        const childPos = index;
        for (let i = this.breadcrumlist.length - 1; i >= 0; i--) {
          if (i > childPos) {
            this.breadcrumlist.pop();
          }
        }

        const model = { nodeId: item.nodeId, NodeName: item.nodeName, siteID: this.siteId };
        this.getNodeImage(model);
        return;
      }

    });
  }
  private setCanvasSize = (isResized: boolean = false) => {
    const temp = document.querySelector('#wrapper');

    if (temp) {
      const bcr = temp.getBoundingClientRect();
      this.canvasWidth = bcr.right - bcr.left;
      if (isResized && this.canvasOriginalWidth !== undefined) {
        this.canvasScaleX = this.canvasWidth / this.canvasOriginalWidth;
      }
      this.canvasOriginalWidth = cloneDeep(this.canvasWidth);
      this.canvas.setWidth(this.canvasWidth);
      this.canvas.setHeight(this.canvasHeight);
    }
  }

  private onImageClick = (e: any) => {
    if (this.commonService.isNullOrUndefined(e.target) || e.target._objects[3].text.includes('sensor')) {
      return;
    }
    const nodeId = e.target._objects[2].text;
    const nodeName = e.target._objects[1].text;
    const model = { nodeId: nodeId, NodeName: nodeName, siteID: this.siteDetail.siteId };
    this.getNodeImage(model);
    this.nodeId = nodeId;
    this.nodeName = nodeName;
  }

  buildFileTree(obj: any, nodes: any, currentSelected: any): any {
    const node = Object.assign({}, obj);
    node.nodeType = obj.nodeType;
    node.index = obj.index;
    node.nodeId = obj.nodeId;
    if (currentSelected != null && currentSelected.nodeId === obj.nodeId) {
      node.selected = true;
    }
    if (obj.nodes.length > 0) {
      node.nodes = [];
      for (let i = 0; i < obj.nodes.length; i++) {
        const element = obj.nodes[i];
        element.index = i;
        node.nodes = this.buildFileTree(element, node.nodes, currentSelected);
      }
    }
    return nodes.concat(node);
  }

  private getChartOption = () => {
    const option = {
      chart: {
        type: 'line',
        height: '185px',
        zoomType: 'xy'
      },
      title: {
        text: ''
      },
      xAxis: {
        categories: ['Jan', 'Feb', 'Mar', 'Apr', 'May', 'Jun']
      },
      credits: {
        enabled: false
      },
      exporting: {
        enabled: false,
      },
      yAxis: {
        title: {
          text: ''
        },
        labels: {
          formatter: function () {
            return '$' + this.value + 'k';
          }
        },
        min: 0
      },
      plotOptions: {
        line: {
          dataLabels: {
            enabled: false
          },
          marker: {
            enabled: false
          },
          enableMouseTracking: false,
          showInLegend: false,
          size: '100%',
        },
      },
      series: [{
        name: 'Data',
        data: [20, 5, 15, 20, 10, 15]
      }]
    };
    return option;

  }

  private getChartOption1 = (sensorData: any) => {
    const title = sensorData.title;
    const xData = sensorData.x;
    const yData = sensorData.y.map(Number);
    const lowerThreshold = sensorData.minValue < sensorData.lowerThreshold ? sensorData.minValue : sensorData.lowerThreshold;
    const upperThreshold = sensorData.maxValue > sensorData.upperThreshold ? sensorData.maxValue : sensorData.upperThreshold;
    const tickInterval = xData.length / 6;
    const unit = sensorData.unit;
    const parameterType = sensorData.parameterTypeDisplayValue;
    const subTitleText = sensorData.y.length > 0 ? '' : 'No data';

    const option = {
      chart: {
        type: 'line',
        height: '185px',
        zoomType: 'x'
      },
      title: {
        text: title,
        align: 'left',
        style: {
          fontWeight: 'bold',
          fontSize: '20px',
        }
      },
      subtitle: {
        align: 'left',
        margin: 20,
        x: 75,
        text: subTitleText,
        style: {
          fontSize: '15px',
        }
      },
      xAxis: {
        tickInterval: tickInterval,
        type: 'datetime',
        labels: {
          formatter: function () {
            return Highcharts$.dateFormat('%H:%M', this.value);
          }
        },
        categories: xData
      },
      credits: {
        enabled: false
      },
      exporting: {
        enabled: false,
      },
      yAxis: {
        lineWidth: 1,
        title: {
          text: ''
        },
        labels: {
          formatter: function () {
            return sensorData.y.length > 0 ? this.value + " " + unit : '';
          }
        },
        min: lowerThreshold,
        max: upperThreshold
      },
      tooltip: {
        formatter: function () {
          return Highcharts$.dateFormat('%b %e, %Y %H:%M:%S', this.x) +
            '<br>' +
            '<span style="color:' + this.series.color + '">\u25CF</span> ' + this.series.name + ': <b>' + this.y + " " + unit + '</b>';
        }
      },
      plotOptions: {
        line: {
          dataLabels: {
            enabled: false
          },
          marker: {
            enabled: false
          },
          // enableMouseTracking: false,
          showInLegend: false,
          size: '100%',
        },
      },
      series: [{
        name: parameterType,
        data: yData
      }]
    };
    return option;

  }

  getSensorTrendForGadgets(model) {
    const self = this;
    this.siteService.getSensorTrendForGadgets(model).subscribe(sensorData => {
      this.oddcharts = [];
      this.evencharts = [];
      this.evenSensors = [];
      this.oddSensors = [];
      this.sensorData = sensorData;
      this.devidesensorData(sensorData);

      setTimeout(() => {
        self.initChartContainer(this.oddSensors, '#oddGraphChart_');
      }, 100);
      setTimeout(() => {
        self.initChartContainer(this.evenSensors, '#evenGraphChart_');
      }, 200);

      const maxXValueTemp = new Date(new Date().getTime() - (1000 * 60 * 60 * 24));
      let maxXValue = maxXValueTemp;
      if (!self.commonService.isNullOrUndefined(self.sensorData)) {
        self.sensorData.forEach(function (sensor) {
          if (sensor && sensor.x && sensor.x.length > 0) {
            const xValue = sensor.x[sensor.x.length - 1];
            if (xValue > maxXValue) {
              maxXValue = sensor.x[sensor.x.length - 1];
            }
          }
        });
      }

      if (maxXValue === maxXValueTemp) {
        // No data
        self.sensorLastUpdatedTxtime = 'Data Not Available for Past 1 hour...!!!!';
      } else {
        // Last sample time
        self.sensorLastUpdatedTxtime = 'Sensor Data as on : ' + this.formatDate(maxXValue, Constants.DATE.INSTANT_DATE_FORMAT);
      }

      const objs = self.canvas.getObjects().map(function (o) {
        const sensorNodeId = o._objects[3].text;
        if (sensorNodeId.startsWith('sensor_')) {
          const nodeName = o._objects[1].text;
          const resplitName = nodeName.split(' : ');
          let found;
          if (!self.commonService.isNullOrUndefined(sensorData) && sensorData.length > 0) {
            found = sensorData.find(c => c.sensorNodeId === sensorNodeId);
          }
          o._objects[1].text = resplitName[0] + ' : ';
          if (!self.commonService.isNullOrUndefined(found)) {
            const value = found.y[found.y.length - 1];
            if (!self.commonService.isNullOrUndefined(value)) {
              o._objects[1].text += value;
              o._objects[1].text += ' ' + found.unit;
            } else {
              o._objects[1].text += '-';
            }
          } else {
            o._objects[1].text += '-';
          }
          // Adjust width of label after adding sensor value
          const test = document.getElementById("hidden-box-to-check-text-width");
          test.innerText = o._objects[1].text;
          o._objects[0].set('width', (test.clientWidth + 11));
        }
        return o;
      });
      self.canvas._objects = objs;
      self.canvas.renderAll();

    });
  }

  getLastRealtimeDataForLoad(model) {
    const param = {
      'siteId': this.siteId,
      'meterId': model.meterId,
      'hideLoading': false,
      'electricParams': model.electricalParameters
    };
    this.loadService.getLastRealtimeDataForLoad(param).subscribe(data => {
      if (!this.commonService.isNullOrUndefined(data)) {
        this.txtime = data['txtime'];
        delete data['txtime'];
        this.loadRTData = data;
        this.rtDataLength = Object.keys(this.loadRTData).length;
      }
    });
  }

  devidesensorData(sensorData) {
    this.evenSensors = [];
    this.oddSensors = [];
    if (!this.commonService.isNullOrUndefined(sensorData)) {
      for (let i = 0; i < sensorData.length; i++) {
        if (i % 2 === 0) {
          this.evenSensors.push(sensorData[i]);
        } else {
          this.oddSensors.push(sensorData[i]);
        }
      }
    }
  }

  initChartContainer(sensorData, typeid) {
    if (!this.commonService.isNullOrUndefined(sensorData)) {
      for (let i = 0; i < sensorData.length; i++) {
        const option = this.getChartOption1(sensorData[i]);
        const id = typeid + i.toString();
        const container = document.querySelector(id);
        this.createChart(container, typeid, option);
      }
    }
  }

  createChart(container, typeid, options?: any) {
    const seft = this;
    const defaultOptions = this.getChartOption();
    const opts = !!options ? options : defaultOptions;
    // const opts = <any>this.getChartOption();
    const e = document.createElement('div');
    e.setAttribute('fxLayout', 'row wrap');
    e.setAttribute('fxFlex', '100%');
    e.setAttribute('style', 'position:relative;width:100%');
    e.addEventListener('click', function () {
      seft.showSensorTrends();
    }, false);
    container.appendChild(e);
    const newChart = Highcharts$.chart(e, opts);
    if (typeid === '#oddGraphChart_') {
      this.oddcharts.push(newChart);
    } else {
      this.evencharts.push(newChart);
    }
  }

  changeToBar(typeid, index) {
    let serie: any;
    let chart: any;

    if (typeid === 'oddGraphChart_') {
      chart = this.oddcharts[index];
    } else {
      chart = this.evencharts[index];
    }
    const bimgName = '#imgBar_' + typeid + index.toString();
    const be = document.querySelector(bimgName);
    be.setAttribute('src', this.barGrayIconPath);

    const limgName = '#imgLine_' + typeid + index.toString();
    const le = document.querySelector(limgName);
    le.setAttribute('src', this.lineIconPath);

    for (let i = 0; i < chart.series.length; i++) {
      serie = chart.series[i];

      chart.addSeries({
        type: 'bar',
        name: serie.name,
        color: serie.color,
        showInLegend: false,
        data: serie.options.data
      }, false);

      serie.remove(false);
    }

    chart.redraw();
  }
  changeToLine(typeid, index) {
    let serie: any;
    let chart: any;
    if (typeid === 'oddGraphChart_') {
      chart = this.oddcharts[index];
    } else {
      chart = this.evencharts[index];
    }

    const limgName = '#imgLine_' + typeid + index.toString();
    const le = document.querySelector(limgName);
    le.setAttribute('src', this.lineGrayIconPath);

    const bimgName = '#imgBar_' + typeid + index.toString();
    const be = document.querySelector(bimgName);
    be.setAttribute('src', this.barIconPath);

    for (let i = 0; i < chart.series.length; i++) {
      serie = chart.series[i];

      chart.addSeries({
        type: 'line',
        name: serie.name,
        color: serie.color,
        showInLegend: false,
        data: serie.options.data
      }, false);

      serie.remove(false);
    }

    chart.redraw();
  }
  /* Method to display Sensor trends */
  showSensorTrends() {
    const seft = this;
    // By default, select all Sensors
    const dialogRef = seft.dialog.open(SensorTrendModalComponent, {
      width: '90%', height: '90%',
      data: { siteId: seft.siteId, sensorDataList: seft.sensorData, nodeId: this.nodeId, nodeName: this.nodeName }
    });

    // dialogRef.componentInstance.sensorDataList = this.sensorData;
    dialogRef.afterClosed().subscribe(result => {
      if (result.status === true) {
        // this.dacData = result.data;
      }
    });
  }
  formatDate(date: any, format: string): string {
    return this.datePipe.transform(date, format) || '';
  }

  updateAlertCount(model: any) {
    const seft = this;
    setTimeout(() => {
      seft.alertInterval = timer(0, seft.alertMinutes * 1000);
      this.alertSubscription = seft.alertInterval.subscribe(() => {
        seft.showAlertCount(model);
      });
    }, 100);
  }

  showAlertCount(model: any) {
    if (this.router.url !== '/') {
      const seft = this;
      const params = {
        'nodeId': model.nodeId,
        'NodeName': model.nodeName,
        'siteID': this.siteId
      };
      this.siteService.getAlertCountForNode(params).subscribe(data => {
        if (data) {
          seft.todayAlert = data.day;
          seft.thisWeekAlert = data.week;
          seft.thisMonthAlert = data.month;
        }
      });
    }
  }
}
